<template>
  <div class="validate-phone-modal">
    <div class="validate-phone-modal__close" @click="$emit('close')">
      <svg><use xlink:href="#svg-close"></use></svg>
    </div>
    <h5 class="validate-phone-modal__title">{{ checkPhone.title }}</h5>

    <form class="validate-phone-modal__form" @submit.prevent="loginByPhone($event)">
      <DefPhone
        v-for="input in authData.authInputs"
        v-if="input.type === 'text'"
        :placeholder="messages.phone"
        :name="input.name"
        :type="input.type"
        :value="authData.authInfo.user_phone_number"
        :error="error"
      />
      <!--            <p class="validate-phone-modal__phone">{{ authData.authInfo.user_phone_number }}</p>-->
      <!--            :value="input.value"-->

      <button type="submit" class="def-button">
        {{ messages.smsCode }}
      </button>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DefPhone from '@components/Def/DefPhone/DefPhone.vue';
import useModal from '@use/useModal/useModal';
import SmsConfirmation from '@components/Cabinet/EnterCabinet/SmsConfirmation.vue';
import Recaptcha3 from '../../../utils/Recaptcha3';

export default {
  name: 'ValidatePhoneModal',
  components: { DefPhone },
  props: ['result'],
  data() {
    return {
      error: '',
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      authData: ({ personal }) => personal.data,
      messages: ({ personal }) => personal.data?.messages,
      checkPhone: ({ personal }) => personal.data.routes.checkPhone,
    }),
  },
  methods: {
    ...mapActions({
      recaptcha: 'personal/recaptcha',
    }),
    async loginByPhone(e) {
      try {
        // const reCaptchaToken = await this.recaptcha({ component: this });
        const reCaptchaToken = await Recaptcha3.getSubmitToken();

        const data = new FormData(e.target);
        const {
          path,
          data: { action, api, LANGUAGE_ID },
        } = this.authData?.routes?.send_sms_code;

        const phone = data.get('USER_LOGIN')?.replace(/[+| |(|)]/g, '');

        data.append('action', action);
        data.append('api', api);
        data.append('lang', LANGUAGE_ID);
        data.append('authType', 'enter');
        data.append('g-recaptcha-response', reCaptchaToken);

        data.set('USER_LOGIN', phone);
        data.append('phone_number', phone);

        const response = await axios.post(path, data);

        if (!response.error && !response.data.error && response.status === 200) {
          this.modal.show(
            SmsConfirmation,
            {
              userPhoneNumber: data.get('USER_LOGIN'),
              userName: data.get('USER_NAME'),
              userLastName: data.get('USER_LAST_NAME'),
              validatePhone: true,
            },
            { width: '440px' }
          );
        } else if (response.data.error) {
          this.error = response.data.error;
          // this.$set(this.errors, 'loginBuyPhone', response.data.error);
        }
      } catch (err) {
        console.error(err);
      }
    },

    userCloseModal({ target }) {
      if (
        !target.closest('.validate-phone-modal') ||
        target.closest('.validate-phone-modal__close')
      ) {
        window.sessionStorage.setItem('phoneValidityRejected', true);
      }
    },
  },
  mounted() {
    // document.addEventListener('click', this.userCloseModal, true);
  },
  beforeUnmount() {
    // document.removeEventListener('click', this.userCloseModal, true);
  },
};
</script>

<style lang="scss" scoped>
.validate-phone-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 20px;
  position: relative;
  @include point-lg {
    padding: 24px 32px;
  }
  &__close {
    position: absolute;
    top: 20px;
    right: 20px;
    margin-left: auto;
    cursor: pointer;
    svg {
      fill: #85898b;
      width: 20px;
      height: 20px;
    }
  }
  &__title {
    text-align: center;
    margin-bottom: 24px;
    font-size: 18px;
  }
  &__phone {
    margin-bottom: 24px;
  }
  &__form {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
  }
  .def-button {
    border: none;
    padding: 0 30px;
    margin-top: 12px;
  }
  ::v-deep {
    .def-phone {
      margin-bottom: 12px;
      width: 100%;
    }
  }
}
</style>
